import { Action } from '../../../common/actions/core/action';
import { Invoice } from '../../services/invoice.model';

export class BillInfoEditDialogAction implements Action {
  constructor(public invoice: Invoice) {}
}



// WEBPACK FOOTER //
// src/app/buy/bill-info/edit/bill-info-edit-dialog.action.ts